import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const GradientHeading = ({ label, variant = 'h2', sx = {}, ...props }) => {
    const theme = useTheme();

    return (
        <Typography
            variant={variant}
            align="center"
            sx={{
                fontWeight: 800,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2,
                ...sx,
            }}
            {...props}
        >
            {label}
        </Typography>
    );
};

export default GradientHeading;
